export const LOGIN_URL = "auth";
export const FORGET_PASSWORD_URL = "auth/forgot-pwd";
export const CHANGE_PASSWORD_URL = "auth/change-pwd";
